// Runs before React mounts (imported first by main.jsx). Kept out of index.html
// so the Content-Security-Policy can refuse inline scripts entirely.
try {
  // Canonical host: the .web.app mirror must not be indexed as a duplicate.
  // Never /__/ — Firebase auth handlers live there.
  if (location.hostname === 'fullrun.web.app' && location.pathname.indexOf('/__/') !== 0) {
    location.replace('https://fullrun.io' + location.pathname + location.search + location.hash);
  }
} catch (e) { /* never block the app on a redirect helper */ }
try {
  // Canonical URL: the homepage's value in index.html, rewritten to THIS route.
  const path = location.pathname.replace(/\/+$/, '') || '/';
  const el = document.querySelector('link[rel="canonical"]');
  if (el) el.setAttribute('href', 'https://fullrun.io' + path);
} catch (e) { /* a wrong canonical is worse than none, but never break the page */ }
